import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22bbc8d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-right" }
const _hoisted_2 = { class: "search-wrap" }
const _hoisted_3 = {
  class: "elem-price-setting",
  "dark-class": "elem-price-setting-dark"
}
const _hoisted_4 = {
  key: 0,
  class: "eps-list"
}
const _hoisted_5 = { class: "eps-card-left" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "商品", -1))
const _hoisted_8 = { class: "meta" }
const _hoisted_9 = {
  key: 0,
  class: "pill"
}
const _hoisted_10 = { class: "pill light" }
const _hoisted_11 = { class: "eps-card-right" }
const _hoisted_12 = { class: "panel-row" }
const _hoisted_13 = { class: "panel price-panel" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "panel-title" }, "商品价格"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-sub" }, "单位：元")
], -1))
const _hoisted_15 = { class: "panel-body" }
const _hoisted_16 = { class: "panel spec-panel" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "panel-title" }, "规格加价"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-sub" }, "为每个规格设置加价")
], -1))
const _hoisted_18 = { class: "panel-body" }
const _hoisted_19 = {
  key: 0,
  class: "spec-table"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spec-row head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col name" }, "规格名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "col price" }, "加价(元)")
], -1))
const _hoisted_21 = { class: "col name readonly" }
const _hoisted_22 = { class: "col price" }
const _hoisted_23 = {
  key: 1,
  class: "spec-empty"
}
const _hoisted_24 = { class: "eps-add-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "暂无商品", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "点击添加商品，配置价格与规格", -1))
const _hoisted_28 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "operate-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_comp_model = _resolveComponent("comp-model")!

  return (_openBlock(), _createBlock(_component_comp_model, {
    ref: "modal",
    title: '价格设置 - ' + $data.companyName,
    width: "80%"
  }, {
    "head-operate": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Input, {
            modelValue: $data.searchKeyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.searchKeyword) = $event)),
            class: "search-input",
            placeholder: "搜索商品名称"
          }, null, 8, ["modelValue"]),
          ($data.searchKeyword)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "search-clear",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.searchKeyword = ''))
              }, [
                _createVNode(_component_Icon, { type: "md-close-circle" })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "btn-add-all",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.addAllProducts && $options.addAllProducts(...args)))
        }, "一键添加全部")
      ])
    ]),
    operate: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_Button, {
          class: "btn-cancel",
          ghost: "",
          onClick: close
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { type: "md-arrow-back" }),
            _createTextVNode(" 取消 ")
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_Button, {
          class: "btn-save",
          type: "primary",
          icon: "md-checkmark",
          onClick: $options.onSave
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        ($data.items.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredItemRows, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "eps-card",
                  key: row.index
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_Select, {
                        modelValue: row.item.goodsUuid,
                        "onUpdate:modelValue": ($event: any) => ((row.item.goodsUuid) = $event),
                        filterable: "",
                        placeholder: "选择商品",
                        onOnChange: val => $options.onProductChange(row.index, val)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.productOptions, (p) => {
                            return (_openBlock(), _createBlock(_component_Option, {
                              key: p.uuid,
                              value: p.uuid
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(p.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "onOnChange"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (row.item.productTitle)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(row.item.productTitle), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_10, "规格 " + _toDisplayString(row.item.specifications.length), 1)
                    ]),
                    _createVNode(_component_Button, {
                      type: "text",
                      icon: "md-trash",
                      class: "remove",
                      onClick: ($event: any) => ($options.removeProduct(row.index))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("移除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_Input, {
                            modelValue: row.item.price,
                            "onUpdate:modelValue": ($event: any) => ((row.item.price) = $event),
                            modelModifiers: { number: true },
                            type: "number",
                            placeholder: $options.placeholderText || '0.00'
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          (row.item.specifications.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _hoisted_20,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.item.specifications, (spec, sIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "spec-row",
                                    key: sIndex
                                  }, [
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(spec.title || "—"), 1),
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(_component_Input, {
                                        modelValue: spec.price,
                                        "onUpdate:modelValue": ($event: any) => ((spec.price) = $event),
                                        modelModifiers: { number: true },
                                        type: "number",
                                        placeholder: "0.00"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, "该商品暂无规格"))
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Button, {
                  class: "add-chip",
                  type: "primary",
                  icon: "md-add",
                  shape: "circle",
                  onClick: $options.addProduct
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加商品")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "eps-empty",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.addProduct && $options.addProduct(...args)))
            }, _hoisted_28))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}